export const groupByCates = ['filters', 'terms', 'histgram'];
